import { render, staticRenderFns } from "./placementList.vue?vue&type=template&id=ea3e6e0e&"
import script from "./placementList.vue?vue&type=script&lang=js&"
export * from "./placementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports